import React, { useCallback, useEffect, useReducer, useState } from "react";
import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import { useCookies } from "react-cookie";
import { add, getList, update } from "./controller";
import AddPopup from "./partials/popups/AddPopup";
import ConfirmPopup from './partials/popups/ConfirmPopup';

export const Context = React.createContext(null);

const initialData = {
  data: {
    list: [],
    total: 0,
    totalPage: 0
  },
  confirmPopup: {
    show: false,
    confirmed: false,
    id: undefined,
  },
  addPopup: {
    show: false,
    id: undefined,
    title: undefined,
    subTitle: undefined,
    confirmed: false,
  },
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_DATA':
      return {
        ...state,
        data: {
          ...action.payload
        }
      }
    case 'OPEN_CONFIRM_POPUP':
      return {
        ...state,
        confirmPopup: {
          show: true,
          confirmed: false,
          id: action.payload.id,
        }
      }
    case 'CLOSE_CONFIRM_POPUP':
      return {
        ...state,
        confirmPopup: {
          show: false,
          id: action.payload ? state.confirmPopup.id : undefined,
          confirmed: action.payload
        }
      }
    case 'OPEN_ADD_POPUP':
      return {
        ...state,
        addPopup: {
          show: true,
          confirmed: false,
          id: action.payload ? action.payload.id : undefined,
          title: action.payload ? action.payload.title : undefined,
          subTitle: action.payload ? action.payload.subTitle : undefined,
        }
      }
    case 'CLOSE_ADD_POPUP':
      return {
        ...state,
        addPopup: {
          show: false,
          confirmed: action.payload.confirmed,
          id: action.payload ? state.addPopup.id : undefined,
          title: action.payload.confirmed ? action.payload.title : undefined,
          subTitle: action.payload.confirmed ? action.payload.subTitle : undefined,
        }
      }
    default:
      return {
        ...state
      }
  }
}

export default () => {

  var [state, dispatch] = useReducer(reducer, initialData);

  const [cookies] = useCookies(['wvivu'])

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const getAllFunc = useCallback(async () => {
    setLoading(true)

    const response = await getList(cookies.wvivu)

    if (response) {
      setError(false)
      dispatch({
        type: 'UPDATE_DATA',
        payload: response
      })
    } else {
      setError(true)
    }
    setLoading(false)
  }, [
    cookies.wvivu,
  ])

  useEffect(() => {
    getAllFunc()
  }, [getAllFunc])

  useEffect(() => {
    document.title = "Nhóm quảng cáo"
  }, []);

  const addFunc = useCallback(async (title, subTitle) => {
    const response = await add(cookies.wvivu, title, subTitle)

    if (response) {
      setError(false)
      getAllFunc()
    } else {
      setError(true)
    }
  }, [
    cookies.wvivu,
    getAllFunc,
  ])

  const deleteFunc = useCallback(async (id) => {

    const response = await update(cookies.wvivu, id, 'DELETE')

    if (response) {
      setError(false)
      getAllFunc()
    } else {
      setError(true)
    }
  }, [
    cookies.wvivu,
    getAllFunc,
  ])
  
  const updateFunc = useCallback(async (id, title, subTitle) => {

    const response = await update(cookies.wvivu, id, 'UPDATE', {
      title: title,
      subTitle: subTitle,
    })

    if (response) {
      setError(false)
      getAllFunc()
    } else {
      setError(true)
    }
  }, [
    cookies.wvivu,
    getAllFunc,
  ])

  useEffect(() => {
    if (state.confirmPopup.confirmed && state.confirmPopup.id) {
      deleteFunc(state.confirmPopup.id)
    }
  }, [deleteFunc, state.confirmPopup.confirmed, state.confirmPopup.id])

  useEffect(() => {
    if (state.addPopup.confirmed) {
      if (!state.addPopup.id) {
        addFunc(state.addPopup.title, state.addPopup.subTitle)
      } else {
        updateFunc(state.addPopup.id, state.addPopup.title, state.addPopup.subTitle)
      }
    }
  }, [addFunc, updateFunc, state.addPopup.confirmed, state.addPopup.title, state.addPopup.subTitle, state.addPopup.id])

  return (
    <Context.Provider value={{
      state,
      dispatch
    }}>

      <FilterForm />

      <br />

      {loading ? 'Loading.....' : error ? 'Lỗi!?' : <Table />}

      <ConfirmPopup />
      <AddPopup />
    </Context.Provider>
  );
};
